import { render, staticRenderFns } from "./ModalEditTeamUserRole.vue?vue&type=template&id=511bb86c&scoped=true"
import script from "./ModalEditTeamUserRole.vue?vue&type=script&lang=js"
export * from "./ModalEditTeamUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511bb86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511bb86c')) {
      api.createRecord('511bb86c', component.options)
    } else {
      api.reload('511bb86c', component.options)
    }
    module.hot.accept("./ModalEditTeamUserRole.vue?vue&type=template&id=511bb86c&scoped=true", function () {
      api.rerender('511bb86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/team/ModalEditTeamUserRole.vue"
export default component.exports